import script from "./ShuangkeStoresComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./ShuangkeStoresComponents.vue?vue&type=script&setup=true&lang=js"

import "./ShuangkeStoresComponents.vue?vue&type=style&index=0&id=00689dfa&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00689dfa"]])

export default __exports__